// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"190":"989a5efc","745":"a523a171"}[chunkId] + ".chunk.css";
};